export default __webpack_public_path__ + "static/media/insta.717871cd.svg";